import React from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import ChannelListItem from 'client/components/common/channel-list/channel-list-item';

const NAVIGATION_BG_HEIGHT = 160;

export default class ChannelList extends Base {
  constructor(props) {
    super(props);

    this.state = {
      currentItem: 0,
      screenWidth: 300,
      showNavigation: {
        left: false,
        right: false,
      },
    };
  }

  static get propTypes() {
    return {
      channels: React.PropTypes.array.isRequired,
      itemWidth: React.PropTypes.number.isRequired,
      itemHeight: React.PropTypes.number.isRequired,
      numberOfRows: React.PropTypes.number.isRequired,
      numberOfCols: React.PropTypes.number,
      showPosition: React.PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      numberOfRows: 1,
      showPosition: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  @autobind
  onResize() {
    this.setState({
      screenWidth: findDOMNode(this.refs.container).getBoundingClientRect()
        .width,
      currentItem: 0,
      showNavigation: {
        left: false,
        right: true,
      },
    });
  }

  @autobind
  onNext() {
    this.setState({
      currentItem: this.state.currentItem + 1,
    });
  }

  @autobind
  onPrevious() {
    this.setState({
      currentItem: this.state.currentItem - 1,
    });
  }

  render() {
    let containerStyle = {
      height: `${this.containerHeight}px`,
    };
    return (
      <div ref="container" className={this.css()} style={containerStyle}>
        {this.items}
        {this.previousNavigation}
        {this.nextNavigation}
      </div>
    );
  }

  // render helpers

  get items() {
    let elements = [];
    let models = this.props.channels;
    let maxNumberOfItems = this.props.numberOfCols * this.props.numberOfRows;

    for (
      var m = 0;
      m < models.length && m < maxNumberOfItems && models[m];
      m++
    ) {
      let column = m % this.props.numberOfCols;
      let active =
        column >= this.state.currentItem &&
        column < this.state.currentItem + this.numberOfColsActiveOnScreen;
      let positionX = this.firstColPosition + column * this.props.itemWidth;
      let positionY =
        Math.floor(m / this.props.numberOfCols) * this.props.itemHeight;

      if (this.props.showPosition) {
        elements.push(
          <ChannelListItem
            key={m}
            position={m + 1}
            model={models[m]}
            active={active}
            positionX={positionX}
            positionY={positionY}
          />
        );
      } else {
        elements.push(
          <ChannelListItem
            key={m}
            model={models[m]}
            active={active}
            positionX={positionX}
            positionY={positionY}
          />
        );
      }
    }

    return elements;
  }

  get previousNavigation() {
    if (this.state.currentItem > 0) {
      return (
        <div
          className="navigation previous"
          onTouch={this.onPrevious}
          onClick={this.onPrevious}
        />
      );
    } else {
      return '';
    }
  }

  get nextNavigation() {
    if (
      this.state.currentItem + this.numberOfColsActiveOnScreen <
      this.usedNumberOfCols
    ) {
      return (
        <div
          className="navigation next"
          onTouch={this.onNext}
          onClick={this.onNext}
        />
      );
    } else {
      return '';
    }
  }

  // helpers

  get containerHeight() {
    return this.usedNumberOfRows * this.props.itemHeight;
  }

  get usedNumberOfRows() {
    return Math.min(
      this.props.numberOfRows,
      Math.ceil(this.props.channels.length / this.props.numberOfCols)
    );
  }

  get usedNumberOfCols() {
    if (this.usedNumberOfRows > 1) {
      return this.props.numberOfCols;
    } else {
      return Math.min(this.props.numberOfCols, this.props.channels.length);
    }
  }

  get numberOfColsActiveOnScreen() {
    if (this.props.itemWidth * this.usedNumberOfCols < this.state.screenWidth) {
      return this.usedNumberOfCols;
    } else {
      return Math.floor(
        this.state.screenWidth /* - this.props.itemWidth*/ /
          this.props.itemWidth
      );
    }
  }

  get centeringOffset() {
    return Math.floor(
      (this.state.screenWidth -
        this.numberOfColsActiveOnScreen * this.props.itemWidth) /
        2
    );
  }

  get firstColPosition() {
    return this.centeringOffset - this.state.currentItem * this.props.itemWidth;
  }
}



// WEBPACK FOOTER //
// ./client/components/common/channel-list/channel-list.es6